import React, { createContext, useContext } from 'react'

const ContainerTitleContext = createContext<string>('')

export const useContainerTitle = () => useContext(ContainerTitleContext)

export const ContainerTitleProvider: React.FC<{ title: string, children: React.ReactNode }> = ({ title, children }) => (
  <ContainerTitleContext.Provider value={title}>{children}</ContainerTitleContext.Provider>
)